import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '../lib/db'
import { useDataVersion } from './useDataVersion'

export function useConversations(category?: string) {
  const dataVersion = useDataVersion()
  // #15: ?? [] fallback to prevent undefined reaching components
  return useLiveQuery(() => {
    if (category) {
      return db.conversations
        .where('category')
        .equals(category)
        .sortBy('lastMessageTimestamp')
        .then((arr) => arr.reverse())
    }
    return db.conversations.orderBy('lastMessageTimestamp').reverse().toArray()
  }, [category, dataVersion]) ?? []
}

export function useConversation(conversationUrn: string | null) {
  const dataVersion = useDataVersion()
  return useLiveQuery(
    () => (conversationUrn ? db.conversations.get(conversationUrn) : undefined),
    [conversationUrn, dataVersion]
  )
}

export function useUnreadCount() {
  const dataVersion = useDataVersion()
  return useLiveQuery(
    () =>
      db.conversations
        .filter((c) => !c.isRead && c.category !== 'ARCHIVE')
        .count(),
    [dataVersion]
  ) ?? 0
}

export function useConversationsByContact(profileUrn: string | null) {
  const dataVersion = useDataVersion()
  return useLiveQuery(
    () =>
      profileUrn
        ? db.conversations.where('participantProfileUrn').equals(profileUrn).toArray()
        : [],
    [profileUrn, dataVersion]
  ) ?? []
}
